<template>
  <div class="realNameCheck">
    <div class="realNameCheck-state" v-if="!beginCheck">
      <div class="realNameCheck-tips">
        <p class="title">
          <span class="tips-title">实名认证</span>
          <span class="under_line"></span>
        </p>
      </div>
      <div class="allReady" v-if="userInfo.authenticated">
        <div class="allReady-logo"></div>
        <p class="allReady-tips">已认证</p>
      </div>
      <div class="noAndTips" v-if="isReady">
        <div class="realNameCheck_content" v-show="!tipPass3">
          <span class="realNameCheck_logo"></span>
          <p
            class="check-tips"
          >应《中华人民共和国网络安全法》要求，2017年6月1日起，使用互联网服务需要进行帐号实名认证。为保障“评论”等功能的正常使用，请您尽快完成认证，感谢您的理解和支持。环球网不会泄露您的隐私信息。</p>
          <div class="realNameCheck_control beginCheck">
            <span class="now-check" @click="startFn()">开始认证</span>
          </div>
        </div>
      </div>
    </div>
    <div class="realNameCheck-process" v-else>
      <div class="realNameCheck-tips">
        <p class="title">
          <span class="tips-title">实名认证</span>
          <span class="under_line"></span>
          <span class="tips-bar">
            <span class="step1_bar" :class="{stepPass:tipPass1 && tipPass2,stepCurrent:tipPass1}">
              实名认证
              <i class="dot" :class="{pass:tipPass1 && tipPass2}"></i>
            </span>
            <span
              class="step2_bar"
              :class="{stepPass:tipPass1 && tipPass2 && tipPass3,stepCurrent:tipPass1 && tipPass2}"
            >
              确认信息
              <i class="dot" :class="{pass:tipPass1 && tipPass2 && tipPass3}"></i>
            </span>
            <span class="step3_bar" :class="{stepCurrent:tipPass1 && tipPass2 && tipPass3}">完成认证</span>
          </span>
          <span
            class="under_line_move"
            :class="{move_step1:tipPass1,move_step2:tipPass2,move_step3:tipPass3}"
          ></span>
        </p>
      </div>
      <div class="realNameCheck_content" v-show="!tipPass3">
        <span class="realNameCheck_logo"></span>
        <el-form
          ref="realNameCheckForm"
          :model="realNameCheckForm"
          :rules="realNameCheckFormRules"
          class="login-form"
          autocomplete="on"
          @submit.native.prevent
        >
          <div class="change-Part">
            <div class="step1" v-show="tipPass1 && !tipPass2">
              <p class="step1-tips">请输入您真实姓名和身份证号码</p>
              <div class="realNameAndIdCard-div">
                <el-form-item class="realNameAndIdCard" prop="realName">
                  <el-input
                    ref="realName"
                    v-model.trim="realNameCheckForm.realName"
                    placeholder="姓名"
                    name="realName"
                    @keyup.enter.native="nextFn()"
                  />
                </el-form-item>
                <el-form-item class="realNameAndIdCard" prop="idCard">
                  <el-input
                    ref="idCard"
                    v-model.trim="realNameCheckForm.idCard"
                    placeholder="身份证号码"
                    name="idCard"
                    @keyup.enter.native="nextFn()"
                  />
                </el-form-item>
                <el-form-item class="realNameAndIdCard" prop="captcha">
                  <el-input
                    v-model.trim="realNameCheckForm.captcha"
                    type="text"
                    maxlength="6"
                    placeholder="校验码"
                    name="captcha"
                    style="width:70%"
                    @keyup.enter.native="nextFn()"
                  />
                  </el-form-item>
                  <img
                    ref="imgCode"
                    :src="codeUrl"
                    class="code-img"
                    alt="校验码"
                    @click="imgCodeRefresh()"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="step2" v-show="tipPass1 && tipPass2 && !tipPass3">
              <p class="step2-tips">实名认证后无法修改，请再次确认信息</p>
              <div class="showInfo-div">
                <p>姓　名：{{realNameCheckForm.realName}}</p>
                <p>身份证：{{realNameCheckForm.idCard}}</p>
              </div>
            </div>
          </div>
        </el-form>
        <div class="realNameCheck_control" :class="{beginCheck:!(tipPass1 && tipPass2)}">
          <span class="pre-step whiteBtn" v-if="tipPass1 && tipPass2" :class="{unAble:whiteLikeAble}" @click="prevFn()">{{prevText}}</span>
          <span class="next-step blueBtn" :class="{unAble:blueLikeAble}" @click="nextFn()">{{nextText}}</span>
        </div>
      </div>
      <div class="step3" v-show="tipPass1 && tipPass2 && tipPass3">
        <span class="success-logo"></span>
        <div class="success-tips">
          <p class="success-title">完成认证</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import user from "@/api/user";
import {
    message
} from '@/utils/resetMessage';
export default {
  name: "realNameCheck",
  components: {},
  data() {
    const validatePhoneCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    const validRealName = (rule, value, callback) => {
      var reg = /^(([a-zA-Z+\.?\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$))/;
      if (value.length > 4 || value.length < 2) {
        callback(new Error("真实姓名长度不合法！"));
      } else if (!reg.test(value)) {
        callback(new Error("姓名不合法！"));
      } else {
        callback();
      }
    };
    const validateIdCard = (rule, value, callback) => {
      var reg = /^(^[1-9]\d{5}[1-9]\d{3}(((0[2])([0|1|2][0-8])|(([0-1][1|4|6|9])([0|1|2][0-9]|[3][0]))|(((0[1|3|5|7|8])|(1[0|2]))(([0|1|2]\d)|3[0-1]))))((\d{4})|\d{3}[Xx])$)$/;
      if (value.length != 18) {
        callback(new Error("身份证号码长度不合法！"));
      } else if (!reg.test(value)) {
        callback(new Error("身份证规则不合法！"));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value.length !== 6) {
        callback(new Error('请输入正确的图形码'))
      } else {
        callback()
      }
    };
    return {
      beginCheck: false,
      isReady: false,
      prevText: "上一步",
      nextText: "下一步",
      tipPass1: true,
      tipPass2: false,
      tipPass3: false,
      show: true,
      able: false,
      whiteLikeAble:false,
      blueLikeAble:false,
      timer: null,
      count: "",
      realNameCheckForm: {
        idCard: "",
        realName: "",
        captcha: ""
      },
      realNameCheckFormRules: {
        realName: [
          { required: true, trigger: "blur", validator: validRealName }
        ],
        idCard: [{ required: true, trigger: "blur", validator: validateIdCard }],
        captcha: [{ required: true, trigger: 'blur', validator: validateCode }]
      },
      userInfo: {},
      codeUrl: ''
    };
  },
  // props: {
  //   userInfo: {
  //     type: Object,
  //     default: {}
  //   }
  // },
  computed: {},
  watch: {},
  created() {
    this.checkLoginState()
  },
  methods: {
    getPicCode() {
      // this.codeUrl = 'http://j577fn.natappfree.cc/' + 'uc/bind-idcard/captcha';
      this.codeUrl = this.varHost + 'uc/bind-idcard/captcha';
    },
    imgCodeRefresh() {
      this.codeUrl = this.varHost + 'uc/bind-idcard/captcha?' + Math.random();
      // this.codeUrl = 'http://j577fn.natappfree.cc/' + 'uc/bind-idcard/captcha?' + Math.random();
    },
    getCode() {
      // 发送请求获取验证码
      this.able = true;
      // 倒计时
      const TIME_COUNT = 90;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            this.able = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    handleCheckNameAndIdCard() {
      this.$refs.realNameCheckForm.validateField("realName", valid => {
        if (!valid) {
          this.$refs.realNameCheckForm.validateField("idCard", valid => {
            if (!valid) {
              this.$refs.realNameCheckForm.validateField("captcha", valid => {
                if (!valid) {
                  this.prevText = "返回修改";
                  this.nextText = "确认提交";
                  this.tipPass2 = true;
                } else {
                  // console.log("error submit!!");
                  return false;
                }
              });
            } else {
              // console.log("error submit!!");
              return false;
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    checkLoginState() {
      user
        .getUserInfo()
        .then(result => {
          this.userInfo = result.data;
          this.isReady = !this.userInfo.authenticated;
        })
        .catch(err => {
          console.log(err);
        });

      // this.userInfo = {"id":2517690,"name":"\u73af\u7403\u7f51\u53cb-IWENZglE","mobile":"13426237543","email":null,"status":"normal","avatar":"https:\/\/m1-1253159997.image.myqcloud.com\/resource\/images\/6e09f1904e2e64d78698defc4fcb9826","created_at":"2022-06-10 18:48:16","updated_at":"2022-06-10 18:48:16","authenticated":false,"hasPassword":true,"socialite_users":[],"information":{"user_id":2517690,"gender":null,"birthday":null,"description":"","province":"","city":"","reg_client_id":null,"reg_ip":"10.0.65.8","last_login_ip":"10.0.65.8","last_login_time":"2022-06-10 18:48:16","last_login_driver":null,"last_login_client_id":null,"plateform":null,"device":null,"business":null,"openid":null,"created_at":"2022-06-10 18:48:16","updated_at":"2022-06-10 18:48:16"},"authentication":null};
      // this.isReady = !this.userInfo.authenticated;
    },
    handSubmit() {
      user
        .realBind({
          real_name: this.realNameCheckForm.realName,
          id_card: this.realNameCheckForm.idCard,
          captcha: this.realNameCheckForm.captcha
        })
        .then(response => {
          // this.$Message.success(response.data.message);
          this.tipPass3 = true;
          setTimeout(() => {
            this.$router.push({name:"index"})
          }, 3000);
          this.checkLoginState()
        })
        .catch(error => {
          if(error.data.errors.captcha[0]==='图形验证码错误' && !error.data.errors.id_card){
            message({
              message: error.data.errors.captcha[0],
              type: 'error',
              duration: 2000
            })
          }
          this.imgCodeRefresh();
        });
    },
    prevFn() {
      if (this.whiteLikeAble) {
        return;
      }
      if (this.tipPass1 && this.tipPass2 && !this.tipPass3) {
        this.tipPass2 = false;
        this.nextText = "下一步";
      }
    },
    nextFn() {
      if (this.blueLikeAble) {
        return
      }
      if (this.tipPass1 && !this.tipPass2) {
        this.handleCheckNameAndIdCard();
      } else if (this.tipPass1 && this.tipPass2 && !this.tipPass3) {
        this.handSubmit();
      }
    },
    startFn() {
      this.beginCheck = true;
      this.getPicCode();
    }
  },
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
.realNameCheck {
  position: relative;
  .realNameCheck-tips {
    width: 640px;
    margin: 30px 40px 0;
    border-bottom: 1px solid #e5e5e5;
    .title {
      color: #4c4c4c;
      font-family: Microsoft YaHei;
      font-weight: 700;
      font-size: 20px;
      line-height: 40px;
      letter-spacing: 0px;
      text-align: left;
      padding-left: 51px;
      position: relative;
      .under_line {
        width: 60px;
        height: 3px;
        position: absolute;
        bottom: 0;
        left: 60px;
        background-color: orange;
      }
      .tips-bar {
        color: #B2B2B2;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        line-height: normal;
        letter-spacing: 0px;
        text-align: left;
        padding-left: 245px;
        .stepCurrent {
          color: #4c4c4c;
        }
        .stepPass {
          color: #4e9e2f;
        }

        .dot {
          background: #c9c9c9;
          width: 3px;
          height: 3px;
          border-radius: 3px;
          display: inline-block;
          margin: 0 5px 4px;
          margin-bottom: 4px;
        }
        .pass {
          background: #4e9e2f;
        }
      }
      .under_line_move {
        width: 60px;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 266px;
        background-color: orange;
      }
      .move_step1 {
        left: 385px;
      }
      .move_step2 {
        left: 472px;
      }
      .move_step3 {
        left: 559px;
      }
    }
  }
  .realNameCheck_content {
    width: 400px;
    height: 306px;
    border-radius: 6px;
    background: #f3f2f0;
    position: absolute;
    left: 165px;
    top: 150px;
    .realNameCheck_logo {
      width: 112px;
      height: 126px;
      position: absolute;
      top: -60px;
      left: 144px;
      display: inline-block;
      background: url("../../../assets/images/icon-2.png") no-repeat center;
    }
    .change-Part {
      margin-top: 70px;

      .step1 {
        .step1-tips {
          color: #595959;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
          margin-top: 24px;
        }
        .realNameAndIdCard-div {
          .realNameAndIdCard {
            width: 260px;
            height: 40px;
            border-radius: 6px;
            background: #ffffff;
            border: 1px solid #cccccc;
            box-shadow: inset 3px 3px 0px 0 #f2f2f2;
            margin: 15px auto;
          }
          .code-img {
            width: 78px;
            height: 40px;
            position: absolute;
            right: 70px;
            top: 115px;
          }
        }
      }
      .step2 {
        padding-top: 10px;
        .step2-tips {
          color: #595959;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .showInfo-div {
          margin: 15px auto;
          width: 270px;
          height: 90px;
          background: #ffffff;
          overflow: hidden;
          p {
            margin-top: 10px;
            color: #000000;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            line-height: 30px;
            letter-spacing: 0px;
            text-align: left;
            padding-left: 24px;
          }
        }
        .againSendMsg-div {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          letter-spacing: 0px;
          text-align: right;
          .againSendMsg {
            color: #4981f2;
            cursor: pointer;
          }
        }
      }
    }
    .realNameCheck_control {
      position: absolute;
      bottom: -14px;
      left: 55px;
      height: 28px;
      span {
        cursor: pointer;
        width: 128px;
        height: 28px;
        margin: 0 6px;
        border-radius: 14px;
        display: inline-block;
        text-align: center;
        color: #4981f2;
        font-family: Microsoft YaHei;
        line-height: 28px;
        font-size: 14px;
        letter-spacing: 0px;
        background: #ffffff;
        border: 1px solid #4981f2;
        box-shadow: inset 0px -2px 0px 0 #cccccc, 0px 2px 0px 0 #e5e5e5;
      }
      .next-step,
      .now-check {
        color: #ffffff;
        background: #4981f2;
        box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
      }
    }
    .realNameCheck_control.beginCheck {
      left: 135px;
    }
    .realNameAndIdCard-div {
      position: relative;
    }
  }
  .step3 {
    height: 234px;
    width: 200px;
    position: absolute;
    left: 260px;
    top: 215px;
    .success-logo {
      width: 170px;
      height: 170px;
      display: inline-block;
      background: url("../../../assets/images/icon-2a.png") no-repeat center;
      margin-left: 15px;
    }
    .success-tips {
      .success-title {
        margin-top: 10px;
        color: #000;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 22px;
        line-height: normal;
        letter-spacing: 0px;
        text-align: center;
        margin-bottom: 6px;
      }
    }
  }
  .noAndTips {
    .check-tips {
      margin: 69px 30px 0;
      color: #4c4c4c;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      line-height: 26px;
      letter-spacing: 0px;
      text-align: left;
      text-indent: 2em;
    }
  }
  .allReady {
    width: 170px;
    height: 224px;
    position: absolute;
    left: 248px;
    top: 202px;
    .allReady-logo {
      width: 170px;
      height: 184px;
      background: url("../../../assets/images/icon-2a.png") no-repeat center;
    }
    .allReady-tips {
      text-align: center;
      margin-top: 11px;
      color: #4c4c4c;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 22px;
      letter-spacing: 0px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/safetyCenter/realNameCheck.vue